'use strict';

const $ = jQuery.noConflict();
$(function() {

	const brandAbout = {

		init: function() {
			this.cacheDOM();
		},

		cacheDOM: function() {
			this.$section = $('.js-brand-about');
		},

	};

	brandAbout.init();
});
